import { Close } from "@mui/icons-material";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import SequenceActions from "../components/SequenceActions";

interface SequenceActionsDialogProps {
  open: boolean;
  onClose: () => void;
  companyId: string;
  sequence?: any;
  getToken: () => Promise<string>;
  initialFilter?: string;
  showAllSequences?: boolean; // If true, show executions from all sequences
}

const SequenceActionsDialog: React.FC<SequenceActionsDialogProps> = ({
  open,
  onClose,
  companyId,
  sequence,
  getToken,
  initialFilter = "unapproved",
  showAllSequences = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">
            {sequence != null ? `Sequence Actions: ${sequence?.name}` : "Sequence Actions"}
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <SequenceActions
          companyId={companyId}
          sequence={sequence}
          getToken={getToken}
          showTitle={false}
          initialFilter={initialFilter}
          showAllSequences={showAllSequences}
        />
      </DialogContent>
    </Dialog>
  );
};

export default SequenceActionsDialog;